import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/critical.css'; // Critical CSS for above-the-fold content
import './index.css';
import App from './App';

// Load non-critical CSS asynchronously
const loadCss = (href) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
};

// After component mounts, load non-critical CSS
window.addEventListener('load', () => {
  setTimeout(() => {
    loadCss(process.env.PUBLIC_URL + '/styles/non-critical.css');
  }, 100);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
